import { Star, WhatsappLogo, CalendarPlus, Phone, ClipboardText } from "@phosphor-icons/react";
import { fileUrl } from "@/lib/site";
import { waUrl, creditText } from "@/components/demo/layouts";

const fmtRating = (r) => Number(r).toLocaleString("pt-PT", { minimumFractionDigits: 1, maximumFractionDigits: 1 });

export function Credit({ c, className = "" }) {
  const t = creditText(c);
  if (!t) return null;
  const cls = `max-w-[92%] truncate whitespace-nowrap text-[10px] leading-none text-white/85 drop-shadow ${className}`;
  return c.uri
    ? <a href={c.uri} target="_blank" rel="noreferrer" className={`${cls} underline-offset-2 hover:underline`} data-testid="photo-credit">{t}</a>
    : <span className={cls} data-testid="photo-credit">{t}</span>;
}

export function RatingChip({ s }) {
  if (!s.google_rating) return null;
  return (
    <div className="dz-rise dz-d3 inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/15 px-3.5 py-1.5 text-sm text-white backdrop-blur-md" data-testid="demo-rating">
      <Star size={16} weight="fill" className="text-amber-400" />
      <b className="text-base">{fmtRating(s.google_rating)}</b>
      {s.google_reviews_count ? <span className="opacity-90">· {Number(s.google_reviews_count).toLocaleString("pt-PT")} avaliações</span> : null}
      {s.from_google && <span className="opacity-75">Google</span>}
    </div>
  );
}

export function DemoHero({ s, L }) {
  const cover = s.cover;
  const left = L.align === "left";
  const primary = s.quote
    ? { href: "#orcamento", label: "Pedir orçamento", icon: ClipboardText, id: "quote" }
    : s.booking
    ? { href: "#reservar", label: "Reservar mesa", icon: CalendarPlus, id: "reserve" }
    : s.phone ? { href: `tel:${s.phone}`, label: "Ligar", icon: Phone, id: "call" } : null;
  return (
    <section className="relative flex h-[100svh] min-h-[600px] items-end overflow-hidden" style={{ background: "var(--d)" }} data-testid="demo-hero">
      {cover && <img src={fileUrl(cover.id)} alt={s.name} fetchpriority="high" decoding="async" className="dz-zoom absolute inset-0 h-full w-full object-cover" data-testid="demo-cover" />}
      <div className="absolute inset-x-0 bottom-0 h-[58%]" style={{ background: "linear-gradient(to top, color-mix(in srgb, var(--d) 88%, transparent) 0%, color-mix(in srgb, var(--d) 55%, transparent) 38%, transparent 100%)" }} />
      <div className="absolute inset-x-0 top-0 h-28" style={{ background: "linear-gradient(to bottom, rgba(0,0,0,.35), transparent)" }} />
      {cover && <Credit c={cover.credit} className="absolute right-3 top-9 z-10 rounded-full bg-black/35 px-2 py-1 backdrop-blur-sm" />}
      <div className={`relative z-10 mx-auto w-full max-w-xl px-6 pb-[max(2rem,env(safe-area-inset-bottom))] text-white [text-shadow:0_1px_12px_rgba(0,0,0,.45)] ${left ? "text-left" : "text-center"}`}>
        {(s.city || s.sector) && <p className="dz-rise mb-3 text-[11px] font-semibold uppercase tracking-[0.28em] text-white/90 drop-shadow">{[s.sector, s.city === "Praia" ? "Cidade da Praia" : s.city].filter(Boolean).join(" · ")}</p>}
        <h1 className="dz-rise dz-d1 text-[2.6rem] font-bold leading-[1.02] drop-shadow-md sm:text-6xl" data-testid="demo-name">{s.name}</h1>
        {s.tagline && <p className="dz-rise dz-d2 mt-3 text-lg leading-snug text-white/95 drop-shadow sm:text-xl" data-testid="demo-tagline">{s.tagline}</p>}
        <div className={`mt-5 ${left ? "" : "flex justify-center"}`}><RatingChip s={s} /></div>
        <div className="dz-rise dz-d4 mt-6 grid grid-cols-2 gap-3 [text-shadow:none]">
          {primary && (
            <a href={primary.href} className={`dz-btn flex h-14 items-center justify-center gap-2 bg-white text-base font-semibold shadow-lg ${s.whatsapp ? "" : "col-span-2"}`} style={{ color: "var(--p)" }} data-testid={`hero-${primary.id}-btn`}>
              <primary.icon size={20} weight="bold" /> {primary.label}
            </a>
          )}
          {s.whatsapp && (
            <a href={waUrl(s.whatsapp)} target="_blank" rel="noreferrer" className={`dz-btn flex h-14 items-center justify-center gap-2 bg-[#25D366] text-base font-semibold text-white shadow-lg ${primary ? "" : "col-span-2"}`} data-testid="hero-whatsapp-btn">
              <WhatsappLogo size={22} weight="fill" /> WhatsApp
            </a>
          )}
        </div>
      </div>
    </section>
  );
}
